import {MutableRefObject, useEffect} from "react";
import {useServices} from "../../hooks/use-services.hook";

export function usePageFooter(pageFooterElementRef: MutableRefObject<HTMLElement | null>) {
    const services = useServices();
    useEffect(() => {
        services.pageFooter.setHtmlElement(pageFooterElementRef.current);
        return () => services.pageFooter.setHtmlElement(null);
    }, [services.pageFooter, pageFooterElementRef]);
}